import styled from "styled-components";

import { Metrics } from "../../vars";

const ToolbarDivider = styled.div`
  height: 100%;
  width: ${Metrics.Widths.TOOLBAR_ITEM_DIVIDER}px;
  background-color: ${(p) => p.theme.colors.grey200};
`;

export default ToolbarDivider;
